export const PLAYER_POSITION_OPTIONS = [
  { value: 'forward', label: 'Forward' },
  { value: 'defense', label: 'Defense' },
  { value: 'goalie', label: 'Goalie' },
  { value: 'unknown', label: 'Unknown / varies' }
]

export const normalizePlayerPosition = value => {
  const position = String(value || '').trim().toLowerCase()
  if (!position) return ''
  if (/goalie|goalkeeper|\bgoalie\b|\bg\b/.test(position)) return 'goalie'
  if (/defen|\bd\b/.test(position)) return 'defense'
  if (/forward|wing|center|centre|\bf\b/.test(position)) return 'forward'
  return 'unknown'
}
